// extracted by mini-css-extract-plugin
export var text = "_3n-0";